var i18n = {
  DE: {
    purchasing: "Kaufen",
    reviews: "Bewertungen",
    order: "bestellungen ",
    invoices: "Rechnungen: ",
    user_management: "Benutzerverwaltung",
    company_admin: "Firmen-Admin",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    invited: "Eingeladen",
    declined: "Declined",
    edit_account: "Account bearbeiten",
    edit_permissions: "Berechtigungen bearbeiten",
    resend_invite: "Resend Invite",
    disable_user: "Benutzer deaktivieren",
    enable_user: "Benutzer aktivieren",
    company: "Unternehmen",
    self: "Selbst",
    none: "Kiner",
    enable_account: "Account aktivieren",
    disable_account: "Account deaktivieren",
    first_name: "Vorname",
    last_name: "Nachname",
    email: "E-mail-Adresse",
    job: "Berufsbezeichnung",
    company: "Unternehmen",
    country: "Land",
    sign_up: "Anmelden",
    searchPlaceholder: "Suche Peerless-AV.com",
    searchByDis: "Suche anhand der angezeigten Modellnummer",
    topRes: "Top Ergebnisse für",
    viewAll: "Alle ansehen",
    results: "ergebnisse",
    products: "Produkte",
    noSearchResults: "0 Ergebnisse gefunden für",
    led_mount_title: "LED-Halterung-Konfigurator",
    kiosk_builder_title: "KioskBuilder™",
    modular_title: "Modularserie-Konfigurator",
    projectName: "Projektname",
    lastEdit: "Letzte Bearbeitung",
    enclosureType: "Enclosure type", // no translation
    typeOfMount: "Type of Mount", // no translation
    ledMakeModel: "LED-Hersteller/Modell",
    status: "Status",
    noSavedConf: "Keine gespeicherten Konfigurationen",
    edit: "Bearbeiten",
    delete: "Löschen",
    invoiceDate: "Rechnungsdatum",
    dueDate: "Fälligkeitsdatum",
    poNumber: "Bestellnummer",
    invoiceNumber: "Rechnungsnummer",
    amount: "Betrag",
    download_print:"Herunterladen und drucken",
    noResult: "Keine Ergebnisse",
    deleteConfigurator : "Möchten Sie Ihren Konfigurationsentwurf wirklich löschen?",
    deleteDraft: "Entwurf löschen?",
    deleteConfiguration: "Konfiguration löschen",
    searchInvoicesPlaceholder: "Suche invoices",
    textShowing: "Ergebnissen ",
    textOf: "de",
    textInvoices: "facturas",
    textTo: "bis",
    draft: "Entwurf",
    submitted_RFQ: "Angebotsanfrage abgeschickt",
    cancel: "Abbrechen",
    createdOrder: "Auftrag erstellt",
    inProcess: "In Bearbeitung",
    delivered: "Geliefert",
    all: "Alle",
    prev: "Bisherige",
    next: "Nächste",
    noOrderFind: "Keine Bestellung",
    backToOrders: "Zurück zu allen Bestellungen",
    orderOn: "Bestellt am",
    orderPurchase: "Bestellung",
    paymentMethod: "Zahlungsmethode",
    quantity: "Menge",
    subtotal: "Zwischensumme",
    tax: "MwSt",
    total: "Gesamt",
    shipped: "Versendet nach",
    cancel_edit: "Abbrechen/Bearbeiten",
    track: "Verfolgen",
    addToCart: "In den Warenkorb legen",
    orderDetails: "Bestelldetails",
    return: "Zurück",
    writeReview: "eine Bewertung schreiben",
    backToOrders: "Zurück zu allen Bestellungen",
    returnRequestForm: "Zurück zum Antragsformular ",
    returnItem: "Bitte wählen Sie aus, welche Artikel Sie zurückschicken möchten. Ein Mitarbeiter unseres Kundendienstteams wird Ihre Anfrage überprüfen und Sie bezüglich Ihrer Rücksendung kontaktieren.",
    returnInformation_p1: "Weitere Informationen zu Retouren finden Sie in",
    returnInformation_p2: "unseren Rückgabe- und Umtauschrichtlinien.",
    returnProduct: "Bitte wählen Sie aus, welche Artikel Sie zurückschicken möchten.",
    returnReason: "Bitte geben Sie einen Grund für Ihre Anfrage an.",
    returnSubmit: "Rücksendeantrag einreichen",
    responseMessage: "Es ist ein Fehler aufgetreten. Bitte neu laden und erneut versuchen",
    search_for_res: "Suche nach Ergebnissen für",
    contactCustomerCare: "Please Conatact Customer Care",
    },
  US: {
    purchasing: "Purchasing",
    reviews: "Reviews",
    order: "orders ",
    invoices: "Invoices: ",
    user_management: "User Management",
    company_admin: "Company Admin",
    edit_account: "Edit Account",
    edit_permissions: "Edit Permissions",
    resend_invite: "Resend Invite",
    disable_user: "Disable User",
    enable_user: "Enable User",
    enabled: "Enabled",
    disabled: "Disabled",
    invited: "Invited",
    declined: "Declined",
    company: "Company",
    self: "Self",
    none: "None",
    enable_account: "Enable account",
    disable_account: "Disable account",
    first_name: "First name",
    last_name: "Last name",
    email: "Email address",
    job: "Job Title",
    company: "Company",
    country: "Country",
    sign_up: "SIGN UP",
    searchPlaceholder: "Search Peerless-AV.com",
    searchByDis: "Search by display model number",
    topRes: "Top results for",
    viewAll: 'View all',
    results: "results",
    products: "Products",
    noSearchResults: "0 results found for",
    led_mount_title: "LED Mount Configurator",
    kiosk_builder_title: "KioskBuilder™",
    modular_title: "Modular Series Configurator",
    projectName: "Project Name",
    lastEdit: "Last Edit",
    enclosureType: "Enclosure type",
    typeOfMount: "Type of Mount",
    ledMakeModel: "LED Make/Model ",
    status: "Status",
    noSavedConf: "No saved configurations",
    edit: "Edit",
    delete: "Delete",
    invoiceDate: "Invoice Date",
    dueDate: "Due Date",
    poNumber: "PO Number",
    invoiceNumber: "Invoice Number",
    amount: "Amount",
    download_print:"Download & Print",
    noResult: "No results",
    deleteConfigurator : "Are you sure you want to delete your configuration draft?",
    deleteDraft: "Delete Draft?",
    deleteConfiguration: "Delete Configuration",
    searchInvoicesPlaceholder: "Search invoices",
    textShowing: "showing",
    textOf: "of",
    textInvoices: "invoices",
    textTo: "to",
    draft: "Draft",
    submitted_RFQ: "RFQ Submitted",
    cancel: "Cancel",
    createdOrder: "Order Created",
    inProcess: "In Process",
    delivered: "Delivered",
    all: "All",
    prev: "prev",
    next: "next",
    noOrderFind: "No order found",
    backToOrders: "Back to All Orders",
    orderOn: "Ordered on",
    orderPurchase: "Purchase order",
    paymentMethod: "Payment Method",
    quantity: "Quantity",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",
    shipped: "Shipped to",
    cancel_edit: "Cancel/Edit",
    track: "Track",
    addToCart: "Add to cart",
    orderDetails: "Order details",
    return: "Return",
    writeReview: "Write a review",
    backToOrders: "Back to All Orders",
    returnRequestForm: "Return request form",
    returnItem: "Please select which items you wish to return. A member of our customer care team will review your request and contact you regarding your return. ",
    returnInformation_p1: "For more information on returns, please review our",
    returnInformation_p2: "return and exchange policy",
    returnProduct: "Please select which products you want to return.",
    returnReason: "Please enter a reason for your request.",
    returnSubmit: "Submit return request",
    responseMessage: "Something went wrong, please reload and try again",
    search_for_res: "Searching for results for",
    contactCustomerCare: "Please Conatact Customer Care",
  },
  ES: {
    purchasing: "Comprando",
    reviews: "Reseñas",
    order: "pedidos ",
    invoices: "Facturas: ",
    user_management: "Gestión de usuarios",
    company_admin: "Adm. de la empresa",
    edit_account: "Editar cuenta",
    edit_permissions: "Editar permisos",
    resend_invite: "Reenviar invitación",
    disable_user: "Desactivar usuario",
    enable_user: "Activar usuario",
    enabled: "Activado",
    disabled: "Desactivado",
    invited: "Invitado",
    declined: "Declined", // no translation 
    company: "Compañía",
    self: "Self", // no translation 
    none: "Ninguno",
    enable_account: "Activar cuenta",
    disable_account: "Desactivar cuenta",
    first_name: "Nombre",
    last_name: "Apellido",
    email: "Dirección de correo electrónico",
    job: "Job Title", // no translation 
    company: "Compañía",
    country: "País",
    sign_up: "SIGN UP", // no translation
    searchPlaceholder: "Buscar Peerless-AV.com",
    searchByDis: "Search by display model number", // no translation
    topRes: "Top results for", // no translation
    viewAll: 'View all', // no translation
    results: "resultados",
    products: "Productos",
    noSearchResults: "No hay resultados",
    led_mount_title: "Configurador de soportes para LED",
    kiosk_builder_title: "KioskBuilder™",
    modular_title: "Configurador de serie Modular ",
    projectName: "Nombre del proyecto",
    lastEdit: "última edición",
    enclosureType: "Enclosure type", // no translation
    typeOfMount: "Type of Mount", // no translation
    ledMakeModel: "Marca/modelo LED",
    status: "Estado",
    noSavedConf: "No hay configuraciones guardadas",
    edit: "Editar",
    noSavedConf: "No hay configuraciones guardadas",
    delete: "Eliminar",
    name: "nombre",
    invoiceDate: "Fecha de factura",
    dueDate: "Fecha de vencimiento",
    poNumber: "Número de orden de compra",
    invoiceNumber: "Número de factura",
    amount: "Cantidad",
    download_print: "Descargar e imprimir",
    noResult: "No hay resultados",
    deleteConfigurator : "¿Está seguro que desea eliminar el borrador de su configuración?",
    deleteDraft: "¿Eliminar borrador?",
    deleteConfiguration: "eliminar configuración",
    searchInvoicesPlaceholder: "Buscar facturas",
    textShowing: "Mostrando",
    textOf: "de",
    textInvoices: "resultados",
    textTo: "a",
    draft: "Borrador",
    submitted_RFQ: "Solicitud de cotización enviada",
    cancel: "Cancelar",
    createdOrder: "Orden creada",
    inProcess: "En proceso",
    delivered: "Entregados",
    all: "Entregados",
    prev: "anterior",
    next: "Siguiente",
    noOrderFind: "Sin orden",
    backToOrders: "Regresar a todos los pedidos",
    orderOn: "Ordenado en",
    orderPurchase: "Regresar a todos los pedidos",
    paymentMethod: "Método de pago",
    quantity: "Cantidad",
    subtotal: "Subtotal",
    tax: "Impuesto",
    total: "Total",
    shipped: "Enviado a ",
    cancel_edit: "Cancelar/Editar",
    track: "Hacer seguimiento",
    addToCart: "Agregar al carrito",
    orderDetails: "Detalles del pedido",
    return: "Devolver",
    writeReview: "escribir una reseña",
    backToOrders: "Regresar a todos los pedidos",
    returnRequestForm: "Devolver formato de solicitud",
    returnItem: "Seleccione los artículos que desea devolver. Un miembro de nuestro equipo de atención al cliente revisará su solicitud y se contactará con usted respecto de su devolución.",
    returnInformation_p1: "Para obtener más información sobre las devoluciones",
    returnInformation_p2: "revise nuestra política de devoluciones e intercambios.",
    returnProduct: "Seleccione los artículos que desea devolver.",
    returnReason: "Por favor ingrese una razón para su solicitud.",
    returnSubmit: "Enviar la solicitud de devolución",
    responseMessage: "Algo salió mal, por favor recargue e intente de nuevo",
    search_for_res: "En busca de resultados",
    contactCustomerCare: "Please Conatact Customer Care",
  },
  FR: {
    purchasing: "Achats",
    reviews: "Avis",
    order: "commandes ",
    invoices: "Factures: ",
    user_management: "Gestion de l'utilisateur",
    company_admin: "Administrateur de l'entreprise",
    edit_account: "Modifier le compte",
    edit_permissions: "Modifier les autorisations",
    resend_invite: "Renvoyer l'invitation",
    disable_user: "Désactiver l'utilisateur",
    enable_user: "Activer l'utilisateur",
    enabled: "Activé",
    disabled: "Désactivé",
    invited: "Invité",
    declined: "Diminué",
    company: "Société",
    self: "Soi",
    none: "Aucun",
    enable_account: "activer le compte",
    disable_account: "Compte désactivé avec succès",
    first_name: "Prénom",
    last_name: "Nom",
    email: "Adresse e-mail",
    job: "Profession",
    company: "Société",
    country: "Pays",
    sign_up: "s'inscrire",
    searchPlaceholder: "Chercher Peerless-AV.com",
    searchByDis: "Recherche par numéro de modèle d'affichage",
    topRes: "Meilleurs résultats pour",
    viewAll: 'Voir tout',
    results: "résultats",
    products: "Des produits",
    noSearchResults: "0 résultats trouvés pour",
    led_mount_title: "Configurateur de support pour panneaux LED",
    kiosk_builder_title: "KioskBuilder™",
    modular_title: "Configurateur pour la série modulaire ",
    projectName: "Nom du projet",
    lastEdit: "dernière modification",
    enclosureType: "Type de boîtier",
    typeOfMount: "Type de montage",
    ledMakeModel: "Modèle/marque du panneau LED ",
    status: "Statut",
    noSavedConf: "Pas de configurations enregistrées",
    edit: "Modifier",
    delete: "Supprimer",
    invoiceDate: "Date de la facture :",
    dueDate: "Date d'échéance",
    poNumber: "Numéro de BC",
    invoiceNumber: "N° de facture",
    amount: "Montant",
    download_print:"Télécharger et imprimer",
    noResult: "Aucun résultat",
    deleteConfigurator : "Voulez-vous supprimer ce brouillon de configuration ?",
    deleteDraft: "Supprimer le brouillon ?",
    deleteConfiguration: "supprimer la configuration",
    searchInvoicesPlaceholder: "Rechercher des factures",
    textShowing: "Affichage",
    textOf: "de",
    textInvoices: "utilisateur(s) sur ",
    textTo: "à",
    draft: "Brouillon",
    submitted_RFQ: "Demande de devis envoyée",
    cancel: "Annulées",
    createdOrder: "Commande créée",
    inProcess: "en cours",
    delivered: "livré",
    all: "tout",
    prev: "précédent",
    next: "suivant",
    noOrderFind: "Aucune commande trouvée",
    backToOrders: "Retour à l'ensemble des commandes",
    orderOn: "Commandées le",
    orderPurchase: "Bon de commande",
    paymentMethod: "mode de paiement",
    quantity: "Quantité",
    subtotal: "Sous-total",
    tax: "Tax",
    total: "Total",
    shipped: "Expédiées à ",
    cancel_edit: "Annuler/Modifier",
    track: "Suivre",
    addToCart: "Ajouter au panier",
    orderDetails: "Détails de la commande",
    return: "retour",
    writeReview: "donner un avis",
    backToOrders: "Retour à l'ensemble des commandes",
    returnRequestForm: "Retour à l'ensemble des commandes",
    returnItem: "Sélectionnez les articles que vous souhaitez renvoyer. Notre service clients traitera votre demande et vous contactera.",
    returnInformation_p1: "Pour plus d'informations sur les renvois, merci de consulter nos",
    returnInformation_p2: " règles de renvoi et d'échange.",
    returnProduct: "Sélectionnez les articles que vous souhaitez renvoyer.",
    returnReason: "Veuillez entrer un motif pour votre demande.",
    returnSubmit: "Envoyer la demande de renvoi",
    responseMessage: "Quelque chose s'est mal passé, rechargez et essayez à nouveau",
    search_for_res: "Aucun résultat pour votre recherche",
    contactCustomerCare: "Please Conatact Customer Care",
  },
};

const ENGLISH_CODE = 'ly73951';

function getCurrentLanguageTranslations () {
  var langs = {
    'ly73951': 'US',
    'ly73952': 'DE',
    'ly73954': 'ES',
    'ly77552': 'FR',
    //UK
    'ly77421': 'US',
    'ly77500': 'DE',
    'ly77423': 'ES',
    'ly77501': 'FR'
  }
  try {
    var currentLang = langify.helper.getSelectedLanguage();
    return i18n[langs[currentLang]] ? i18n[langs[currentLang]] : i18n['US'];
  } catch (e) {
    console.log(e);
    return i18n['US'];
  }
}

function getCurrentLanguage() {
  var langs = {
    'ly73951': 'US',
    'ly73952': 'DE',
    'ly73954': 'ES',
    'ly77552': 'FR',
    //UK
    'ly77421': 'US',
    'ly77500': 'DE',
    'ly77423': 'ES',
    'ly77501': 'FR',
    //DE
    'ly77505': 'US',
    'ly77305': 'DE',
    'ly77504': 'ES',
    'ly77506': 'FR',
    //FR
    'ly77508': 'US',
    'ly77507': 'DE',
    'ly77509': 'ES',
    'ly77422': 'FR',
    //ES
    'ly77432': 'US',
    'ly77513': 'DE',
    'ly77429': 'ES',
    'ly77512': 'FR',
  }
  try {
    // if(typeof globalCart.attributes.language !== 'undefined')
    //   return langs[globalCart.attributes.language];
    return langs[langify.helper.getSelectedLanguage()];
  } catch(e) {}
  return 'US';
};

function getCurrentLanguageCode() {
  try {
    return langify.helper.getSelectedLanguage();
    if(typeof globalCart.attributes.language !== 'undefined')
      return globalCart.attributes.language;
  } catch(e) {}
  return 'ly73951';
};

function getTranslation(translationObj, key) {
  return translationObj[key] ? translationObj[key] : i18n['US'][key] ? i18n['US'][key] : '';
}


  
    window.currentSite = 'global';
  

  function getCurrentLangCode() {
    var lang_codes = {
      'US': 'ly73951',
      'DE': 'ly73952',
      'ES': 'ly73954',
      'FR': 'ly77552'
    }
    try {
      return lang_codes[getCurrentLanguage()];
    } catch(e) {
      return ENGLISH_CODE;
    }
  };

function getCurrentStoreIndice(prefix) {
  var currentLang = getCurrentLanguage().toLowerCase();
  var indices = {
    global: {
      us: prefix + 'products',
      fr: 'global_fr_' + prefix + 'products',
      es: 'global_es_' + prefix + 'products',
    },
    english: {
      us: 'english_us_' + prefix + 'products',
      es: 'english_es_' + prefix + 'products'
    },
    french: {
      fr: 'french_fr_' + prefix + 'products'
    },
    german: {
      de: 'german_de_' + prefix + 'products'
    },
    latin_america: {
      us: 'latin_america_us_' + prefix + 'products',
      es: 'latin_america_es_' + prefix + 'products'
    }
  };
  try {
    return indices[currentSite][currentLang];
  } catch(e) {
    return indices['global']['us'];
  }
}